import { render } from "./OrofacialPain.vue?vue&type=template&id=eca076d0"
import script from "./OrofacialPain.vue?vue&type=script&lang=js"
export * from "./OrofacialPain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__